import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../context/AlertContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Link, Redirect } from "react-router-dom";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "../../assets/css/DropDown.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Navigate, useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import * as EmailValidator from "email-validator";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

export default function RecetasMedicasGenerar(props) {
  //const classes = useStyles();
  const [globalFilter, setGlobalFilter] = useState(null);
  const [paciente, guardarPaciente] = useState(null);

  const sexos = [
    { nombre: "M", dataKey: "m" },
    { nombre: "F", dataKey: "f" },
    { nombre: "O", dataKey: "o" },
  ];

  let navigate = useNavigate();
  const [medico, guardarMedico] = useState(null);
  const toast = useRef(null);
  const toastWarm = useRef(null);
  const [band, setBand] = useState(true);
  const stepperRef = useRef(null);
  const stepperRef2 = useRef(null);
  const [buscarPaciente, setBuscarPaciente] = useState(null);
  const [exit, setExit] = useState(false);
  const [searchParams] = useSearchParams();
  const [medicamentoElegido, setMedicamentoElegido] = useState(null);
  const [cantidadMedicamento, setCantidadMedicamento] = useState(null);
  const [presentacionElegida, setPresentacionElegida] = useState(null);
  const [medicamentosRecetas, setMedicamentosRecetas] = useState([]);
  const [visible, setVisible] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [activeStep1, setActiveStep1] = useState(0);
  const [skipped1, setSkipped1] = useState(new Set());
  const [selectedRow, setSelectedRow] = useState(null);
  const [visibleFinal, setVisibleFinal] = useState(false);

  const steps = ["Residente", "Receta"];
  const steps1 = ["Medicamentos", "Presentación", "Cantidad"];

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const serviciosContext = useContext(ServiciosContext);
  const {
    statusAcceso,
    configuracion,
    medicos,
    medicamentos,
    presentaciones,
    obrasSocialesMedicas,
    pacienteSeleccionado,
    geriatricoElegido,
    obtenerPacienteId,
    guardarPacienteSeleccionado,
    obtenerObrasSocialesMedicas,
    obtenerObrasSocialesRecetario,
    obtenerMedicamentos,
    obtenerMedicos,
    setGeriatricoElegido,
  } = serviciosContext;

  const medicoId = searchParams.get("medicoId");
  const pacienteId = searchParams.get("pacienteId");

  useEffect(() => {
    //obtenerObrasSocialesMedicas({ todos: false });
    obtenerObrasSocialesRecetario();
    obtenerMedicamentos();
    obtenerMedicos({ todos: false });
    guardarPacienteSeleccionado(null);
    setGeriatricoElegido({
      id: Number(localStorage.getItem("geriatricoElegidoId")),
      nombre: localStorage.getItem("geriatricoElegidoNombre"),
      domicilio: localStorage.getItem("geriatricoElegidoDomicilio"),
      telefono: localStorage.getItem("geriatricoElegidoTelefono"),
    });

  }, []);

  const exitClick = (e) => {
    navigate(`/`);
  };

  const onHide = (e) => {
    window.top.close();
    //window.location.reload("/");
  };

  const agregarMedicamento = () => {
    const copyArray = [...medicamentosRecetas];

    copyArray.push({
      medicamento:
        medicamentoElegido.marcaComercial +
        " - " +
        medicamentoElegido.principioActivo,
      presentacion: presentacionElegida.presentacion,
      cantidad: cantidadMedicamento,
      code: presentacionElegida.code,
      tratamientoProlongado: pacienteSeleccionado.tratamientoProlongado,
      duplicado: pacienteSeleccionado.duplicado,
      respetarMarca: pacienteSeleccionado.respetarMarca,
    });

    setMedicamentosRecetas(copyArray);
    setVisible(false);
  };

  const eliminarMedicamento = (data, index) => {
    medicamentosRecetas.splice(index, 1);
    let elem = document.getElementById("cancelarMedicamento");
    if (elem) {
      elem.click();
    }
  };

  function validarPaciente() {
    if (
      !pacienteSeleccionado ||
      pacienteSeleccionado.apellido === undefined ||
      pacienteSeleccionado.apellido === null ||
      pacienteSeleccionado.apellido.trim() === ""
    ) {
      mensajeAlerta("Receta", "El apellido es necesario !.", "error");
      return false;
    }

    if (
      !pacienteSeleccionado ||
      pacienteSeleccionado.nombre === undefined ||
      pacienteSeleccionado.nombre === null ||
      pacienteSeleccionado.nombre.trim() === ""
    ) {
      mensajeAlerta("Receta", "El nombre es necesario !.", "error");
      return false;
    }

    if (
      !pacienteSeleccionado ||
      pacienteSeleccionado.numeroDocumento === undefined ||
      pacienteSeleccionado.numeroDocumento === null ||
      pacienteSeleccionado.numeroDocumento.trim() === "" ||
      Number(pacienteSeleccionado.numeroDocumento) === 0
    ) {
      mensajeAlerta("Receta", "El Nº de Documento es necesario !.", "error");
      return false;
    }

    if (
      !pacienteSeleccionado ||
      pacienteSeleccionado.nacimiento === undefined ||
      pacienteSeleccionado.nacimiento === null ||
      pacienteSeleccionado.nacimiento.trim() === ""
    ) {
      mensajeAlerta("Receta", "Fecha de nacimiento es necesaria !.", "error");
      return false;
    }

    if (
      !pacienteSeleccionado ||
      pacienteSeleccionado.sexo === undefined ||
      pacienteSeleccionado.sexo === null ||
      pacienteSeleccionado.sexo.trim() === ""
    ) {
      mensajeAlerta("Receta", "El sexo es necesario !.", "error");
      return false;
    }

    if (
      !pacienteSeleccionado ||
      pacienteSeleccionado.obraSocial === undefined ||
      pacienteSeleccionado.obraSocial === null ||
      pacienteSeleccionado.obraSocial.trim() === ""
    ) {
      mensajeAlerta("Receta", "La obra social es necesaria !.", "error");
      return false;
    }

    if (
      pacienteSeleccionado &&
      pacienteSeleccionado.obraSocial.toUpperCase().trim() !== "PARTICULAR"
    ) {
      if (
        !pacienteSeleccionado ||
        pacienteSeleccionado.numeroObraSocial === undefined ||
        pacienteSeleccionado.numeroObraSocial === null ||
        pacienteSeleccionado.numeroObraSocial.trim() === "" ||
        Number(pacienteSeleccionado.numeroObraSocial) === 0
      ) {
        mensajeAlerta(
          "Receta",
          "El Nº de obra social es necesario !.",
          "error"
        );
        return false;
      }
    }

    if (
      pacienteSeleccionado &&
      pacienteSeleccionado.email &&
      !EmailValidator.validate(pacienteSeleccionado.email)
    ) {
      mensajeAlerta("Receta", "El correo electrónico no es válido !.", "error");
      return false;
    }

    if (
      pacienteSeleccionado &&
      pacienteSeleccionado.telefono &&
      pacienteSeleccionado.telefono.trim().length !== 10
    ) {
      mensajeAlerta("Receta", "El celular debe tener 10 dígitos !.", "error");
      return false;
    }

    //return false
    return true;
  }

  const aceptarClick = async (e) => {
    //Validar

    if (!medicamentosRecetas || medicamentosRecetas.length <= 0) {
      mensajeAlerta(
        "Recetas",
        "Es necesario agregar algún medicamento !.",
        "error"
      );
      return;
    }

    if (
      !pacienteSeleccionado ||
      pacienteSeleccionado.fecha === undefined ||
      pacienteSeleccionado.fecha === null ||
      pacienteSeleccionado.fecha.trim() === ""
    ) {
      mensajeAlerta("Receta", "Fecha es necesaria !.", "error");
      return false;
    }

    if (
      !pacienteSeleccionado ||
      pacienteSeleccionado.diagnostico === undefined ||
      pacienteSeleccionado.diagnostico === null ||
      pacienteSeleccionado.diagnostico.trim() === ""
    ) {
      mensajeAlerta("Receta", "Diagnóstico es necesario !.", "error");
      return false;
    }

    let medicines = [];

    for (var i = 0; i < medicamentosRecetas.length; i++) {
      medicines.push({
        externalId: medicamentosRecetas[i].code,
        quantity: Number(medicamentosRecetas[i].cantidad),
        genericOnly: !medicamentosRecetas[i].respetarMarca,
        longTerm: medicamentosRecetas[i].tratamientoProlongado,
        requiresDuplicate: medicamentosRecetas[i].duplicado,
      });
    }

    //console.log(pacienteSeleccionado)

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      `Bearer ${process.env.REACT_APP_RECETARIO_TOKEN}`
    );

    var raw = JSON.stringify({
      userId: Number(medicoId),
      date: pacienteSeleccionado.fecha,
      patient: {
        healthInsurance: pacienteSeleccionado.obraSocial.trim(),
        insuranceNumber: pacienteSeleccionado.numeroObraSocial
          ? pacienteSeleccionado.numeroObraSocial.trim()
          : "",
        name: pacienteSeleccionado.nombre.trim(),
        surname: pacienteSeleccionado.apellido.trim(),
        documentNumber: pacienteSeleccionado.numeroDocumento.trim(),
        email: pacienteSeleccionado.email.trim(),
        phone: pacienteSeleccionado.telefono
          ? pacienteSeleccionado.telefono.trim()
          : "",
        gender: pacienteSeleccionado.sexo.toLowerCase(),
        birthDate: pacienteSeleccionado.nacimiento,
      },
      method: "vademecum",
      diagnosis: pacienteSeleccionado.diagnostico,
      medicines,
    });

    //console.log(raw);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    /*    
    fetch("https://external-api.recetario.com.ar/prescriptions", requestOptions)
   .then(response => response.text())
   .then(result => console.log(result))
   .catch(error => console.log('error', error));
    */

    try {
      let response = await fetch(
        "https://external-api.recetario.com.ar/prescriptions",
        requestOptions
      );

      //console.log(response)

      if (response.ok) {
        toast.current.show({
          severity: "success",
          summary: "Recetas",
          detail: "La receta se ha generado correctamente.",
          life: 3000,
        });

        const json = await response.json();

        let url = json.url;
        window.open(url, "_blank");

        let idMedico = medicos.find(
          (element) => element.recetarioId === Number(medicoId)
        ).id;

        let datos = {
          medicoId: idMedico,
          pacienteId,
          telefono: pacienteSeleccionado.telefono,
          email: pacienteSeleccionado.email,
          enviarWhatsApp: pacienteSeleccionado.enviarWhatsApp,
          enviarCorreo: pacienteSeleccionado.enviarCorreo,
          url,
          geriatricoElegido,
        };

        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };

        await axios
          .post(
            process.env.REACT_APP_BACKEND_URL + "/api/servicios/agregarrecetarecetario",
            datos,
            config
          )
          .then(function (response) {
            console.log(response);
          });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Recetas",
          detail: "Hubo un error al generar la receta.",
          life: 3000,
        });
      }
    } catch (error) {
      console.error(error.message);
    }

    setTimeout(() => {
      onHide();
    }, 5000);
  };

  // INICIO

  if (medicoId && pacienteId && !pacienteSeleccionado) {
    obtenerPacienteId({ id: pacienteId });
  }

  if (pacienteSeleccionado && band) {
    setBand(false);
    guardarPacienteSeleccionado({
      ...pacienteSeleccionado,
      ...(pacienteSeleccionado.email
        ? {
            enviarCorreo: true,
          }
        : {}),

      ...(pacienteSeleccionado.telefono
        ? {
            enviarWhatsApp: true,
          }
        : {}),
    });
  }

  // FIN

  const itemTemplate = (rowData, options) => {
    const icon = "pi pi-trash";
    return (
      <Button
        type="button"
        icon={icon}
        severity={"danger"}
        className="p-button-sm p-button-text"
        onClick={() => eliminarMedicamento(rowData, options.rowIndex)}
      />
    );
  };

  const prolongadoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">T. Prolongado</span>
        <Checkbox checked={rowData.tratamientoProlongado}></Checkbox>
      </Fragment>
    );
  };

  const duplicadoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Duplicado</span>
        <Checkbox checked={rowData.duplicado}></Checkbox>
      </Fragment>
    );
  };

  const respetarTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Respetar Marca</span>
        <Checkbox checked={rowData.respetarMarca}></Checkbox>
      </Fragment>
    );
  };

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    if (activeStep === 0) {
      if (
        !pacienteSeleccionado ||
        pacienteSeleccionado.apellido === undefined ||
        pacienteSeleccionado.apellido === null ||
        pacienteSeleccionado.apellido.trim() === ""
      ) {
        mensajeAlerta("Receta", "El apellido es necesario !.", "error");
        return false;
      }

      if (
        !pacienteSeleccionado ||
        pacienteSeleccionado.nombre === undefined ||
        pacienteSeleccionado.nombre === null ||
        pacienteSeleccionado.nombre.trim() === ""
      ) {
        mensajeAlerta("Receta", "El nombre es necesario !.", "error");
        return false;
      }

      if (
        !pacienteSeleccionado ||
        pacienteSeleccionado.numeroDocumento === undefined ||
        pacienteSeleccionado.numeroDocumento === null ||
        pacienteSeleccionado.numeroDocumento.trim() === "" ||
        Number(pacienteSeleccionado.numeroDocumento) === 0
      ) {
        mensajeAlerta("Receta", "El Nº de Documento es necesario !.", "error");
        return false;
      }

      if (
        !pacienteSeleccionado ||
        pacienteSeleccionado.nacimiento === undefined ||
        pacienteSeleccionado.nacimiento === null ||
        pacienteSeleccionado.nacimiento.trim() === ""
      ) {
        mensajeAlerta("Receta", "Fecha de nacimiento es necesaria !.", "error");
        return false;
      }

      if (
        !pacienteSeleccionado ||
        pacienteSeleccionado.sexo === undefined ||
        pacienteSeleccionado.sexo === null ||
        pacienteSeleccionado.sexo.trim() === ""
      ) {
        mensajeAlerta("Receta", "El sexo es necesario !.", "error");
        return false;
      }

      if (
        !pacienteSeleccionado ||
        pacienteSeleccionado.obraSocial === undefined ||
        pacienteSeleccionado.obraSocial === null ||
        pacienteSeleccionado.obraSocial.trim() === ""
      ) {
        mensajeAlerta("Receta", "La obra social es necesaria !.", "error");
        return false;
      }

      if (
        pacienteSeleccionado &&
        pacienteSeleccionado.obraSocial.toUpperCase().trim() !== "PARTICULAR"
      ) {
        if (
          !pacienteSeleccionado ||
          pacienteSeleccionado.numeroObraSocial === undefined ||
          pacienteSeleccionado.numeroObraSocial === null ||
          pacienteSeleccionado.numeroObraSocial.trim() === "" ||
          Number(pacienteSeleccionado.numeroObraSocial) === 0
        ) {
          mensajeAlerta(
            "Receta",
            "El Nº de obra social es necesario !.",
            "error"
          );
          return false;
        }
      }

      if (
        pacienteSeleccionado &&
        pacienteSeleccionado.email &&
        !EmailValidator.validate(pacienteSeleccionado.email)
      ) {
        mensajeAlerta(
          "Receta",
          "El correo electrónico no es válido !.",
          "error"
        );
        return false;
      }

      if (
        pacienteSeleccionado &&
        pacienteSeleccionado.telefono &&
        pacienteSeleccionado.telefono.trim().length !== 10
      ) {
        mensajeAlerta("Receta", "El celular debe tener 10 dígitos !.", "error");
        return false;
      }
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  //2 Stepper

  const isStepOptional1 = (step) => {
    return step === 1;
  };

  const isStepSkipped1 = (step) => {
    return skipped1.has(step);
  };

  const handleBack1 = () => {
    setActiveStep1((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext1 = () => {
    let newSkipped = skipped1;
    if (isStepSkipped1(activeStep1)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep1);
    }

    if (activeStep1 === 0 && !medicamentoElegido) {
      toast.current.show({
        severity: "warn",
        summary: "Receta",
        detail: "Debe seleccionar un medicamento.",
        life: 3000,
      });
      return;
    }

    if (activeStep1 === 1 && !presentacionElegida) {
      toast.current.show({
        severity: "warn",
        summary: "Receta",
        detail: "Debe seleccionar una presentación.",
        life: 3000,
      });
      return;
    }

    if (
      activeStep1 === 2 &&
      (!cantidadMedicamento || Number(cantidadMedicamento) <= 0)
    ) {
      toast.current.show({
        severity: "warn",
        summary: "Receta",
        detail: "Debe seleccionar una cantidad.",
        life: 3000,
      });
      return;
    }

    if (activeStep1 === 2) {
      agregarMedicamento();
      setVisibleFinal(true);
      return;
    }

    setActiveStep1((prevActiveStep) => prevActiveStep + 1);
    setSkipped1(newSkipped);
  };

  //console.log(medicamentosRecetas);
  //console.log(pacienteSeleccionado);

  return (
    <Fragment>
      <Toast ref={toast} />
      <Toast ref={toastWarm} position="top-right" />
      {pacienteId && medicoId && pacienteSeleccionado ? (
        <Fragment>
          <Box sx={{ width: "100%" }}>
            <Stepper activeStep={activeStep}>
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>

            <Fragment>
              {activeStep === 0 ? (
                <Fragment>
                  <div className="flex flex-column h-12rem">
                    <div className="flex pt-4 justify-content-end">
                      <Grid
                        container
                        spacing={3}
                        sx={{ marginTop: "1vw", marginLeft: "0vw" }}
                      >
                        <Grid item xs={11} md={5}>
                          <TextField
                            value={
                              pacienteSeleccionado
                                ? pacienteSeleccionado.apellido
                                : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            required
                            id="Apellido"
                            label="Apellido"
                            fullWidth
                            variant="standard"
                            onChange={(e) =>
                              guardarPacienteSeleccionado({
                                ...pacienteSeleccionado,
                                apellido: e.target.value,
                              })
                            }
                          />
                        </Grid>

                        <Grid item xs={11} md={5}>
                          <TextField
                            value={
                              pacienteSeleccionado
                                ? pacienteSeleccionado.nombre
                                : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            required
                            id="Nombre"
                            label="Nombre"
                            fullWidth
                            variant="standard"
                            onChange={(e) =>
                              guardarPacienteSeleccionado({
                                ...pacienteSeleccionado,
                                nombre: e.target.value,
                              })
                            }
                          />
                        </Grid>

                        <Grid item xs={11} md={1.5}>
                          <TextField
                            value={
                              pacienteSeleccionado
                                ? pacienteSeleccionado.numeroDocumento
                                : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            required
                            id="numeroDocumento"
                            label="D.N.I."
                            fullWidth
                            variant="standard"
                            onChange={(e) =>
                              guardarPacienteSeleccionado({
                                ...pacienteSeleccionado,
                                numeroDocumento: e.target.value,
                              })
                            }
                          />
                        </Grid>

                        <Grid item xs={5} md={2}>
                          <TextField
                            id="nacimiento"
                            label="Fecha Nacimiento"
                            type="date"
                            variant="standard"
                            value={
                              pacienteSeleccionado
                                ? pacienteSeleccionado.nacimiento
                                : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            required
                            onChange={(e) => {
                              guardarPacienteSeleccionado({
                                ...pacienteSeleccionado,
                                nacimiento: e.target.value,
                              });
                            }}
                          />
                        </Grid>

                        <Grid item xs={6} md={1.8}>
                          <Dropdown
                            value={
                              pacienteSeleccionado && pacienteSeleccionado.sexo
                                ? sexos[
                                    sexos.findIndex(
                                      (element) =>
                                        element.nombre ===
                                        pacienteSeleccionado.sexo
                                    )
                                  ]
                                : null
                            }
                            onChange={(e) => {
                              if (e.value) {
                                guardarPacienteSeleccionado({
                                  ...pacienteSeleccionado,
                                  sexo: e.value.nombre,
                                });
                              } else {
                                guardarPacienteSeleccionado({
                                  ...pacienteSeleccionado,
                                  sexo: null,
                                });
                              }
                            }}
                            options={sexos}
                            optionLabel="nombre"
                            showClear
                            placeholder="Seleccione un sexo"
                            style={{ marginLeft: "1vw", marginTop: ".75vw" }}
                          />
                        </Grid>

                        <Grid item xs={11} md={4}>
                          <label htmlFor="id">Obra Social: </label>

                          <Dropdown
                            value={
                              obrasSocialesMedicas &&
                              pacienteSeleccionado &&
                              pacienteSeleccionado.obraSocial
                                ? obrasSocialesMedicas[
                                    obrasSocialesMedicas.findIndex(
                                      (element) =>
                                        element.name.toUpperCase() ===
                                        pacienteSeleccionado.obraSocial.toUpperCase()
                                    )
                                  ]
                                : null
                            }
                            onChange={(e) => {
                              if (e.value) {
                                guardarPacienteSeleccionado({
                                  ...pacienteSeleccionado,
                                  obraSocial: e.value.name,
                                });
                              } else {
                                guardarPacienteSeleccionado({
                                  ...pacienteSeleccionado,
                                  obraSocial: null,
                                });
                              }
                            }}
                            options={obrasSocialesMedicas}
                            optionLabel="name"
                            showClear
                            filter
                            placeholder="Seleccione obra social"
                            className="w-full"
                            style={{ marginLeft: "1vw", marginTop: ".75vw" }}
                          />
                        </Grid>

                        <Grid item xs={11} md={3}>
                          <TextField
                            value={
                              pacienteSeleccionado
                                ? pacienteSeleccionado.numeroObraSocial
                                : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            id="numeroObraSocial"
                            label="Nº Obra Social"
                            fullWidth
                            variant="standard"
                            onChange={(e) =>
                              guardarPacienteSeleccionado({
                                ...pacienteSeleccionado,
                                numeroObraSocial: e.target.value,
                              })
                            }
                          />
                        </Grid>

                        <Grid item xs={11} md={8}>
                          <TextField
                            value={
                              pacienteSeleccionado
                                ? pacienteSeleccionado.email
                                : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            id="email"
                            label="Correo Electrónico"
                            fullWidth
                            variant="standard"
                            onChange={(e) => {
                              if (e.target.value) {
                                guardarPacienteSeleccionado({
                                  ...pacienteSeleccionado,
                                  email: e.target.value,
                                  enviarCorreo: true,
                                });
                              } else {
                                guardarPacienteSeleccionado({
                                  ...pacienteSeleccionado,
                                  email: null,
                                  enviarCorreo: false,
                                });
                              }
                            }}
                          />
                        </Grid>

                        <Grid item xs={11} md={3.5}>
                          <TextField
                            value={
                              pacienteSeleccionado
                                ? pacienteSeleccionado.telefono
                                : null
                            }
                            InputLabelProps={{
                              shrink: true,
                            }}
                            id="telefono"
                            label="Celular"
                            fullWidth
                            variant="standard"
                            onChange={(e) => {
                              if (e.target.value) {
                                guardarPacienteSeleccionado({
                                  ...pacienteSeleccionado,
                                  telefono: e.target.value,
                                  enviarWhatsApp: true,
                                });
                              } else {
                                guardarPacienteSeleccionado({
                                  ...pacienteSeleccionado,
                                  telefono: null,
                                  enviarWhatsApp: false,
                                });
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={5} md={2} sx={{ marginRight: "0.5em" }}>
                          <FormControlLabel
                            value="yes"
                            control={
                              <Checkbox
                                color="primary"
                                checked={
                                  pacienteSeleccionado
                                    ? pacienteSeleccionado.enviarCorreo
                                    : null
                                }
                                style={{ marginLeft: "0.5em" }}
                                onChange={(e) =>
                                  guardarPacienteSeleccionado({
                                    ...pacienteSeleccionado,
                                    enviarCorreo: e.target.checked,
                                  })
                                }
                              />
                            }
                            label="Enviar Correo"
                            labelPlacement="start"
                          />
                        </Grid>

                        <Grid item xs={5} md={2} sx={{ marginRight: "0.5em" }}>
                          <FormControlLabel
                            value="yes"
                            control={
                              <Checkbox
                                color="primary"
                                checked={
                                  pacienteSeleccionado
                                    ? pacienteSeleccionado.enviarWhatsApp
                                    : null
                                }
                                style={{ marginLeft: "0.5em" }}
                                onChange={(e) =>
                                  guardarPacienteSeleccionado({
                                    ...pacienteSeleccionado,
                                    enviarWhatsApp: e.target.checked,
                                  })
                                }
                              />
                            }
                            label="Enviar WhatsApp"
                            labelPlacement="start"
                          />
                        </Grid>

                        <Grid item xs={12} md={12} />
                      </Grid>

                      <Grid
                        item
                        size={{ xs: 12, md: 12 }}
                        sx={{ marginTop: "2em", marginLeft: "1vw" }}
                      >
                        <div className="flex pt-4 justify-content-between">
                          <Button
                            label="Salir"
                            icon="pi pi-times"
                            iconPos="right"
                            severity="danger"
                            style={{ marginRight: "1vw" }}
                            onClick={() => onHide()}
                          />

                          <Button
                            label="Receta"
                            icon="pi pi-arrow-right"
                            iconPos="right"
                            onClick={() => {
                              handleNext();
                            }}
                          />
                        </div>
                      </Grid>
                    </div>
                  </div>
                </Fragment>
              ) : null}

              {activeStep === 1 ? (
                <Fragment>
                  <div className="flex flex-column h-12rem">
                    <div className="flex pt-4 justify-content-end">
                      <DataTable
                        value={medicamentosRecetas}
                        size={"small"}
                        tableStyle={{ minWidth: "50rem" }}
                        style={{ marginLeft: "1vw" }}
                        emptyMessage="No hay datos"
                      >
                        <Column
                          field="medicamento"
                          header="Medicamento"
                        ></Column>
                        <Column
                          field="presentacion"
                          header="Presentación"
                        ></Column>
                        <Column field="cantidad" header="Cantidad"></Column>
                        <Column
                          field="prolongado"
                          header="T. Prolongado"
                          body={prolongadoTemplate}
                        ></Column>
                        <Column
                          field="duplicado"
                          header="Duplicado"
                          body={duplicadoTemplate}
                        ></Column>
                        <Column
                          field="respetar"
                          header="Respetar Marca"
                          body={respetarTemplate}
                        ></Column>
                        <Column
                          style={{ flex: "0 0 4rem" }}
                          body={itemTemplate}
                        ></Column>
                      </DataTable>

                      <div className="flex pt-4 justify-content-between">
                        <Button
                          label="Agregar"
                          severity="success"
                          icon="pi pi-check"
                          className="p-button-rounded p-button-help"
                          style={{
                            marginRight: "1vw",
                            marginTop: "2vw",
                            marginLeft: "1vw",
                            marginBottom: "1vw",
                          }}
                          onClick={() => {
                            setMedicamentoElegido(null);
                            setPresentacionElegida(null);
                            setCantidadMedicamento(null);
                            guardarPacienteSeleccionado({
                              ...pacienteSeleccionado,
                              tratamientoProlongado: false,
                              duplicado: false,
                              respetarMarca: false,
                            });
                            setVisible(true);
                            setActiveStep1(0);
                            setVisibleFinal(false);
                          }}
                        />
                        <Button
                          id="cancelarMedicamento"
                          label="Cancelar"
                          severity="danger"
                          icon="pi pi-times"
                          className="p-button-rounded p-button-help"
                          iconPos="right"
                          style={{
                            marginBottom: "1vw",
                          }}
                          onClick={() => {
                            setMedicamentoElegido(null);
                            setPresentacionElegida(null);
                            setCantidadMedicamento(null);
                            guardarPacienteSeleccionado({
                              ...pacienteSeleccionado,
                              tratamientoProlongado: false,
                              duplicado: false,
                              respetarMarca: false,
                            });
                            setVisible(false);
                          }}
                        />
                      </div>

                      {visible ? (
                        <Box sx={{ width: "100%" }}>
                          <Stepper activeStep={activeStep1}>
                            {steps1.map((label, index) => {
                              const stepProps = {};
                              const labelProps = {};
                              return (
                                <Step key={label} {...stepProps}>
                                  <StepLabel {...labelProps}>{label}</StepLabel>
                                </Step>
                              );
                            })}
                          </Stepper>

                          <Fragment>
                            {activeStep1 === 0 ? (
                              <Fragment>
                                <div className="flex flex-column h-12rem">
                                  <div className="flex pt-4 justify-content-end">
                                    <Grid
                                      container
                                      spacing={3}
                                      sx={{
                                        marginTop: "1vw",
                                        marginLeft: "0vw",
                                      }}
                                    >
                                      <Grid
                                        item
                                        xs={4}
                                        md={4}
                                        sx={{
                                          marginTop: {
                                            xs: "-3vw",
                                            md: "0vw",
                                          },
                                          marginLeft: "-1em",
                                          marginRight: ".5em",
                                        }}
                                      >
                                        <FormControlLabel
                                          value="yes"
                                          control={
                                            <Checkbox
                                              color="primary"
                                              checked={
                                                pacienteSeleccionado
                                                  ? pacienteSeleccionado.tratamientoProlongado
                                                  : null
                                              }
                                              style={{ marginLeft: "0.5em" }}
                                              onChange={(e) =>
                                                guardarPacienteSeleccionado({
                                                  ...pacienteSeleccionado,
                                                  tratamientoProlongado:
                                                    e.target.checked,
                                                })
                                              }
                                            />
                                          }
                                          label="Tratamiento Prolongado"
                                          labelPlacement="start"
                                        />
                                      </Grid>
                                      <Grid
                                        item
                                        xs={4}
                                        md={4}
                                        sx={{ marginRight: "0.5em" }}
                                      >
                                        <FormControlLabel
                                          value="yes"
                                          control={
                                            <Checkbox
                                              color="primary"
                                              checked={
                                                pacienteSeleccionado
                                                  ? pacienteSeleccionado.duplicado
                                                  : null
                                              }
                                              style={{ marginLeft: "0.5em" }}
                                              onChange={(e) =>
                                                guardarPacienteSeleccionado({
                                                  ...pacienteSeleccionado,
                                                  duplicado: e.target.checked,
                                                })
                                              }
                                            />
                                          }
                                          label="Duplicado"
                                          labelPlacement="start"
                                        />
                                      </Grid>
                                      <Grid
                                        item
                                        xs={4}
                                        md={4}
                                        sx={{
                                          marginTop: {
                                            xs: "-3vw",
                                            md: "0vw",
                                          },
                                          marginLeft: "-1em",
                                        }}
                                      >
                                        <FormControlLabel
                                          value="yes"
                                          control={
                                            <Checkbox
                                              color="primary"
                                              checked={
                                                pacienteSeleccionado
                                                  ? pacienteSeleccionado.respetarMarca
                                                  : null
                                              }
                                              style={{ marginLeft: "0.5em" }}
                                              onChange={(e) =>
                                                guardarPacienteSeleccionado({
                                                  ...pacienteSeleccionado,
                                                  respetarMarca:
                                                    e.target.checked,
                                                })
                                              }
                                            />
                                          }
                                          label="Respetar Marca"
                                          labelPlacement="start"
                                        />
                                      </Grid>
                                    </Grid>

                                    <Grid
                                      item
                                      xs={12}
                                      md={5}
                                      style={{
                                        marginLeft: "1vw",
                                        marginTop: "1vw",
                                      }}
                                    >
                                      <Dropdown
                                        value={medicamentoElegido}
                                        onChange={(e) => {
                                          setMedicamentoElegido(e.value);
                                          setPresentacionElegida(null);
                                        }}
                                        options={medicamentos}
                                        optionLabel="detalle"
                                        placeholder="Seleccione un medicamento"
                                        filter
                                        showClear
                                        className="w-full md:w-12rem"
                                      />
                                    </Grid>
                                  </div>

                                  <Grid item xs={12} md={12} />

                                  <div className="flex py-4">
                                    <Button
                                      label="Presentación"
                                      icon="pi pi-arrow-right"
                                      iconPos="right"
                                      style={{
                                        marginTop: "2vw",
                                        marginLeft: "1vw",
                                      }}
                                      onClick={() => handleNext1()}
                                    />
                                  </div>
                                </div>
                              </Fragment>
                            ) : null}

                            {activeStep1 === 1 ? (
                              <Fragment>
                                <div className="flex flex-column h-14rem">
                                  <div className="flex pt-4 justify-content-end">
                                    <Grid
                                      container
                                      spacing={3}
                                      style={{ marginTop: "0vw" }}
                                    >
                                      <Grid
                                        item
                                        xs={12}
                                        md={3}
                                        style={{ marginLeft: "1vw" }}
                                      >
                                        <Dropdown
                                          value={presentacionElegida}
                                          onChange={(e) => {
                                            if (e.value) {
                                              setPresentacionElegida(e.value);
                                            } else {
                                              setPresentacionElegida(null);
                                            }
                                          }}
                                          options={
                                            presentaciones &&
                                            presentaciones.length > 0 &&
                                            medicamentoElegido
                                              ? presentaciones.filter(
                                                  (element) =>
                                                    element.id ===
                                                    medicamentoElegido.id
                                                )
                                              : null
                                          }
                                          optionLabel="presentacion"
                                          showClear
                                          placeholder="Seleccione una Presentación"
                                          className="w-full md:w-14rem"
                                        />
                                      </Grid>
                                    </Grid>
                                  </div>

                                  <Grid item xs={12} md={12} />

                                  <div className="flex py-4 gap-2">
                                    <Button
                                      label="Medicamentos"
                                      severity="secondary"
                                      icon="pi pi-arrow-left"
                                      style={{
                                        marginRight: "1vw",
                                        marginTop: "2vw",
                                        marginLeft: "1vw",
                                      }}
                                      onClick={() => handleBack1()}
                                    />
                                    <Button
                                      label="Cantidad"
                                      icon="pi pi-arrow-right"
                                      iconPos="right"
                                      onClick={() => handleNext1()}
                                    />
                                  </div>
                                </div>
                              </Fragment>
                            ) : null}

                            {activeStep1 === 2 ? (
                              <Fragment>
                                <div className="flex flex-column h-14rem">
                                  <div className="flex pt-4 justify-content-end">
                                    <Grid
                                      item
                                      xs={6}
                                      md={2}
                                      style={{ marginLeft: "1vw", marginTop: "1vw" }}
                                    >
                                      <TextField
                                        value={
                                          cantidadMedicamento
                                            ? cantidadMedicamento
                                            : ""
                                        }
                                        type="number"
                                        required
                                        id="cantidad"
                                        label="Cantidad"
                                        fullWidth
                                        variant="standard"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        onChange={(e) => {
                                          setCantidadMedicamento(
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </Grid>
                                  </div>

                                  <Grid item xs={12} md={12} />
                                  <div className="flex py-4">
                                    <Button
                                      label="Presentación"
                                      severity="secondary"
                                      icon="pi pi-arrow-left"
                                      style={{
                                        marginTop: "2vw",
                                        marginLeft: "1vw",
                                      }}
                                      onClick={() => handleBack1()}
                                    />
                                    <Button
                                      label="Agregar Medicamento"
                                      icon="pi pi-check"
                                      iconPos="right"
                                      style={{ marginLeft: "1vw" }}
                                      onClick={() => handleNext1()}
                                    />
                                  </div>
                                </div>
                              </Fragment>
                            ) : null}
                          </Fragment>
                        </Box>
                      ) : null}

                      {visibleFinal ? (
                        <Grid
                          container
                          spacing={3}
                          style={{
                            marginTop: "2vw",
                            marginLeft: "0vw",
                          }}
                        >
                          <Grid item xs={6} md={2}>
                            <TextField
                              id="fecha"
                              label="Fecha"
                              type="date"
                              variant="standard"
                              value={
                                pacienteSeleccionado
                                  ? pacienteSeleccionado.fecha
                                  : null
                              }
                              InputLabelProps={{
                                shrink: true,
                              }}
                              required
                              onChange={(e) => {
                                guardarPacienteSeleccionado({
                                  ...pacienteSeleccionado,
                                  fecha: e.target.value,
                                });
                              }}
                            />
                          </Grid>

                          <Grid item xs={11} md={9}>
                            <TextField
                              id="diagnostico"
                              label="Diagnóstico"
                              variant="standard"
                              value={
                                pacienteSeleccionado
                                  ? pacienteSeleccionado.diagnostico
                                  : null
                              }
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fullWidth
                              required
                              multiline
                              onChange={(e) => {
                                guardarPacienteSeleccionado({
                                  ...pacienteSeleccionado,
                                  diagnostico: e.target.value,
                                });
                              }}
                            />
                          </Grid>
                        </Grid>
                      ) : null}
                    </div>

                    <Grid
                      item
                      size={{ xs: 12, md: 12 }}
                      sx={{ marginTop: "2em", marginLeft: "1vw" }}
                    >
                      <Button
                        label="Residentes"
                        className="p-button-success"
                        icon="pi pi-arrow-left"
                        style={{ marginRight: "1vw" }}
                        onClick={() => handleBack()}
                      />
                      <Button
                        label="Generar Receta"
                        className="p-button-success"
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        disabled={
                          !medicamentosRecetas ||
                          medicamentosRecetas.length <= 0
                        }
                        style={{ marginRight: "1vw" }}
                        onClick={() => {
                          aceptarClick();
                        }}
                      />
                    </Grid>
                  </div>
                </Fragment>
              ) : null}
            </Fragment>
          </Box>
        </Fragment>
      ) : (
        <Spinner />
      )}
      <Grid item xs={12} md={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
